import axios from 'axios';

export class WebAlertRepository {
    constructor(host, region) {
        this.host = host;
        this.region = region;
    }

    async fetchStatistics(endpoint, startDate, endDate) {
        try {
            const response = await axios.get(
                `${this.host}/api/analyze/${endpoint}`,
                {
                    params: {
                        Region: this.region,
                        start: startDate,
                        end: endDate
                    }
                }
            );

            if (response.data.code === 0) {
                return response.data.data;
            }
            return [];
        } catch (error) {
            console.error(`Error fetching ${endpoint}:`, error);
            throw error;
        }
    }
}
